export const generateFetchLatestMoviesRequestObj = (
  translation: string,
  languages: string,
  country: string,
  genre?: string[]
) => {
  const requestObj = {
    filter: {
      page: 1,
      limit: 25,
      country,
      translation: translation,
      languages,
      assetSubType: 'movie',
      itemType: 'latest',
      sortBy: 'release_date',
      version: '2',
      sortOrder: 'desc',
      genres: genre
    }
  };
  return requestObj;
};
